import { render } from "./consumptionPrint.vue?vue&type=template&id=796af344&scoped=true"
import script from "./consumptionPrint.vue?vue&type=script&lang=js"
export * from "./consumptionPrint.vue?vue&type=script&lang=js"

import "./consumptionPrint.vue?vue&type=style&index=0&id=796af344&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796af344"]])

export default __exports__